import { useRouteMatch } from 'react-router';

import { menuEditorRoutePrefix, onboardingRoutePrefix } from './routes';

type RouteMatchParams = Parameters<typeof useRouteMatch>[0];

export function useIsRoutePartOf(params: RouteMatchParams): boolean {
  return !!useRouteMatch(params);
}

export function useIsOnboardingRoute(): boolean {
  return useIsRoutePartOf(onboardingRoutePrefix);
}

export function useIsMenuEditorRoute(): boolean {
  return useIsRoutePartOf(menuEditorRoutePrefix);
}
